import { Directive } from '@angular/core';

@Directive({
  selector: '[prizmExpandContent]',
  standalone: true,
})
export class PrizmExpandContentDirective {}
